export var browserStorage = {
  available: function () {
    if (typeof localStorage !== 'undefined') return true
  },
  get: function (key) {
    return JSON.parse(localStorage.getItem(key) || null)
  },
  set: function (key, value) {
    localStorage.setItem(key, JSON.stringify(value))
  },
  remove: function (key) {
    localStorage.removeItem(key)
  },
  clear: function () {
    if (window.confirm('Are you clear Local Data ?')) {
      localStorage.clear()
      window.location.reload()
    }
  },
}
